import { render, staticRenderFns } from "./autenticaSenha.vue?vue&type=template&id=34b0da58"
import script from "./autenticaSenha.vue?vue&type=script&lang=js"
export * from "./autenticaSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports